export const SHOW_LOGIN_FORM_LOADER = "SHOW_LOGIN_FORM_LOADER";
export const HIDE_LOGIN_FORM_LOADER = "HIDE_LOGIN_FORM_LOADER";
export const SHOW_EQUEUES_LOADER = "SHOW_EQUEUES_LOADER";
export const HIDE_EQUEUES_LOADER = "HIDE_EQUEUES_LOADER";
export const SHOW_CANCEL_EQUEUE_LOADER = "SHOW_CANCEL_EQUEUE_LOADER";
export const HIDE_CANCEL_EQUEUE_LOADER = "HIDE_CANCEL_EQUEUE_LOADER";
export const SHOW_USER_INFO_LOADER = "SHOW_USER_INFO_LOADER";
export const HIDE_USER_INFO_LOADER = "HIDE_USER_INFO_LOADER";
export const SHOW_DOCTORS_LOADER = "SHOW_DOCTORS_LOADER";
export const HIDE_DOCTORS_LOADER = "HIDE_DOCTORS_LOADER";
export const SHOW_DOCTOR_NAMES_LOADER = "SHOW_DOCTOR_NAMES_LOADER";
export const HIDE_DOCTOR_NAMES_LOADER = "HIDE_DOCTOR_NAMES_LOADER";
export const SHOW_DATES_LOADER = "SHOW_DATES_LOADER";
export const HIDE_DATES_LOADER = "HIDE_DATES_LOADER";
export const SHOW_CONFIRM_LOADER = "SHOW_CONFIRM_LOADER";
export const HIDE_CONFIRM_LOADER = "HIDE_CONFIRM_LOADER";
export const SHOW_SELECTED_EQUEUE_LOADER = "SHOW_SELECTED_EQUEUE_LOADER";
export const HIDE_SELECTED_EQUEUE_LOADER = "HIDE_SELECTED_EQUEUE_LOADER";
export const SHOW_REGIONS_LOADER = "SHOW_REGIONS_LOADER";
export const HIDE_REGIONS_LOADER = "HIDE_REGIONS_LOADER";
export const SHOW_BOOKING_LOADER = "SHOW_BOOKING_LOADER";
export const HIDE_BOOKING_LOADER = "HIDE_BOOKING_LOADER";

export const USER_AUTHENTICATION_STARTED = "USER_AUTHENTICATION_STARTED";
export const USER_AUTHENTICATION_SUCCESS = "USER_AUTHENTICATION_SUCCESS";
export const USER_AUTHENTICATION_FAILED = "USER_AUTHENTICATION_FAILED";

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

export const EQUEUES_LIST_LOADING_SUCCESS = "EQUEUES_LIST_LOADING_SUCCESS";
export const EQUEUES_LIST_LOADING_FAILED = "EQUEUES_LIST_LOADING_FAILED";
export const CLEAR_EQUEUES_LIST = "CLEAR_EQUEUES_LIST";

export const RESTART_PANELS_HISTORY = "RESTART_PANELS_HISTORY";
export const RESET_PANELS_STATE = "RESET_PANELS_STATE";
export const SET_ACTIVE_PANEL = "SET_ACTIVE_PANEL";
export const SET_PREVIOUS_PANEL = "SET_PREVIOUS_PANEL";
export const SET_ACTIVE_NON_ERROR_PANEL = "SET_ACTIVE_NON_ERROR_PANEL";

export const SET_SELECTED_EQUEUE_FAILED = "SET_SELECTED_EQUEUE_FAILED";
export const SET_SELECTED_EQUEUE = "SET_SELECTED_EQUEUE";
export const REMOVE_SELECTED_EQUEUE = "REMOVE_SELECTED_EQUEUE";

export const CANCEL_EQUEUE_SUCCESS = "CANCEL_EQUEUE_SUCCESS";
export const CANCEL_EQUEUE_FAILED = "CANCEL_EQUEUE_FAILED";

export const SET_CUSTOM_ERROR_MESSAGE = "SET_CUSTOM_ERROR_MESSAGE";

export const USER_INFO_LOADING_SUCCESS = "USER_INFO_LOADING_SUCCESS";
export const USER_INFO_LOADING_FAILED = "USER_INFO_LOADING_FAILED";

export const R_N_M_FIRST_STEP_LOADING_SUCCESS =
  "R_N_M_FIRST_STEP_LOADING_SUCCESS";
export const R_N_M_FIRST_STEP_LOADING_FAILED =
  "R_N_M_FIRST_STEP_LOADING_FAILED";

export const R_N_M_SECOND_STEP_LOADING_SUCCESS =
  "R_N_M_SECOND_STEP_LOADING_SUCCESS";
export const R_N_M_SECOND_STEP_LOADING_FAILED =
  "R_N_M_SECOND_STEP_LOADING_FAILED";

export const R_N_M_THIRD_STEP_LOADING_SUCCESS =
  "R_N_M_THIRD_STEP_LOADING_SUCCESS";
export const R_N_M_THIRD_STEP_LOADING_FAILED =
  "R_N_M_THIRD_STEP_LOADING_FAILED";

export const R_N_M_FOURTH_STEP_LOADING_SUCCESS =
  "R_N_M_FOURTH_STEP_LOADING_SUCCESS";
export const R_N_M_FOURTH_STEP_LOADING_FAILED =
  "R_N_M_FOURTH_STEP_LOADING_FAILED";
export const R_N_M_FOURTH_STEP_LOADING_STARTED =
  "R_N_M_FOURTH_STEP_LOADING_STARTED";

export const R_N_M_FIFTH_STEP_LOADING_SUCCESS =
  "R_N_M_FIFTH_STEP_LOADING_SUCCESS";
export const R_N_M_FIFTH_STEP_LOADING_FAILED =
  "R_N_M_FIFTH_STEP_LOADING_FAILED";

export const R_N_M_FIFTH_STEP_LOADING_FAILED_WITH_MESSAGE =
  "R_N_M_FIFTH_STEP_LOADING_FAILED_WITH_MESSAGE";

export const R_N_M_SIXTH_STEP_LOADING_SUCCESS =
  "R_N_M_SIXTH_STEP_LOADING_SUCCESS";
export const R_N_M_SIXTH_STEP_LOADING_FAILED =
  "R_N_M_SIXTH_STEP_LOADING_FAILED";

export const SELECT_MEDICAL_ORGANISATION = "SELECT_MEDICAL_ORGANISATION";

export const RESTART_STEPS = "RESTART_STEPS";

export const DETECT_REGION = "DETECT_REGION";
export const SELECT_REGION = "SELECT_REGION";
export const SELECT_EQUEUE = "SELECT_EQUEUE";

export const DOCTORS_SPECIALITIES_LOADING_SUCCESS =
  "DOCTORS_SPECIALITIES_LOADING_SUCCESS";
export const DOCTORS_SPECIALITIES_LOADING_FAILED =
  "DOCTORS_SPECIALITIES_LOADING_FAILED";

export const SELECT_DOCTORS_SPECIALITY = "SELECT_DOCTORS_SPECIALITY";

export const DOCTOR_NAMES_LOADING_SUCCESS = "DOCTOR_NAMES_LOADING_SUCCESS";
export const DOCTOR_NAMES_LOADING_FAILED = "DOCTOR_NAMES_LOADING_FAILED";

export const CLEAN_NAME_SELECTOR = "CLEAN_NAME_SELECTOR";

export const DATES_LOADING_SUCCESS = "DATES_LOADING_SUCCESS";
export const DATES_LOADING_FAILED = "DATES_LOADING_FAILED";

export const SELECT_DOCTOR_NAME = "SELECT_DOCTOR_NAME";
export const SELECT_DATE = "SELECT_DATE";

export const SELECT_DAY = "SELECT_DAY";
export const SELECT_TIME = "SELECT_TIME";
export const SELECT_SLOT = "SELECT_SLOT";
export const CLEAR_DATE_TIME = "CLEAR_DATE_TIME";

export const EQUEUE_BOOKING_SUCCESS = "EQUEUE_BOOKING_SUCCESS";
export const EQUEUE_BOOKING_FAILED = "EQUEUE_BOOKING_FAILED";

export const LOAD_USER_REGION_SUCCESS = "LOAD_USER_REGION_SUCCESS";
export const LOAD_USER_REGION_FAILED = "LOAD_USER_REGION_FAILED";

export const SET_ACTIVE_ALERT = "SET_ACTIVE_ALERT";
export const SET_SNILS = "SET_SNILS";
export const USER_AVATAR_LOADING_SUCCESS = "USER_AVATAR_LOADING_SUCCESS";
export const SET_DEFAULT_VALUE = "SET_DEFAULT_VALUE";

export const SHOW_EQUEUES_SNACKBAR = "SHOW_EQUEUES_SNACKBAR";
export const HIDE_EQUEUES_SNACKBAR = "HIDE_EQUEUES_SNACKBAR";
export const CLEAR_R_N_M = "CLEAR_R_N_M";

export const SET_ENTERED_OMS = "SET_ENTERED_OMS";
export const CLEAR_ENTERED_OMS = "CLEAR_ENTERED_OMS";

export const SHOW_MOSCOW_SCENARIO_LOADER = "SHOW_MOSCOW_SCENARIO_LOADER";
export const HIDE_MOSCOW_SCENARIO_LOADER = "HIDE_MOSCOW_SCENARIO_LOADER";

export const MOSCOW_SCENARIO_REGIONS_BANS_NOT_FOUND =
  "MOSCOW_SCENARIO_REGIONS_BANS_NOT_FOUND";
export const MOSCOW_SCENARIO_REGIONS_BANS_FOUND =
  "MOSCOW_SCENARIO_REGIONS_BANS_FOUND";

export const MOSCOW_SCENARIO_ORDER_ID_SUCCESS =
  "MOSCOW_SCENARIO_ORDER_ID_SUCCESS";
export const MOSCOW_SCENARIO_ORDER_ID_FAILED =
  "MOSCOW_SCENARIO_ORDER_ID_FAILED";

export const MOSCOW_PATIENT_VALIDATION_SUCCESS =
  "MOSCOW_PATIENT_VALIDATION_SUCCESS";
export const MOSCOW_PATIENT_VALIDATION_FAILED =
  "MOSCOW_PATIENT_VALIDATION_FAILED";

export const MOSCOW_SPECIALITIES_LOADING_SUCCESS =
  "MOSCOW_SPECIALITIES_LOADING_SUCCESS";
export const MOSCOW_SPECIALITIES_LOADING_FAILED =
  "MOSCOW_SPECIALITIES_LOADING_FAILED";

export const MOSCOW_SCENARIO_SELECT_SPECIALITY =
  "MOSCOW_SCENARIO_SELECT_SPECIALITY";

export const MOSCOW_SCENARIO_LOAD_DOCTOR_NAMES_SUCCESS =
  "MOSCOW_SCENARIO_LOAD_DOCTOR_NAMES_SUCCESS";
export const MOSCOW_SCENARIO_LOAD_DOCTOR_NAMES_FAILED =
  "MOSCOW_SCENARIO_LOAD_DOCTOR_NAMES_FAILED";

export const MOSCOW_SCENARIO_SELECT_DOCTOR_NAME =
  "MOSCOW_SCENARIO_SELECT_DOCTOR_NAME";

export const MOSCOW_SCENARIO_LOAD_MEDICAL_ORGANISATION_SUCCESS =
  "MOSCOW_SCENARIO_LOAD_MEDICAL_ORGANISATION_SUCCESS";
export const MOSCOW_SCENARIO_LOAD_MEDICAL_ORGANISATION_FAILED =
  "MOSCOW_SCENARIO_LOAD_MEDICAL_ORGANISATION_FAILED";

export const SET_API_BASE_AUTH_ADDRESS = "SET_API_BASE_AUTH_ADDRESS";

export const MOSCOW_SCENARIO_CLEAR_ERROR = "MOSCOW_SCENARIO_CLEAR_ERROR";
export const MOSCOW_SCENARIO_CLEAR_REGION = "MOSCOW_SCENARIO_CLEAR_REGION";

export const SET_EXCEPTIONS = "SET_EXCEPTIONS";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const CLEAN_ERROR_MESSAGE = "CLEAN_ERROR_MESSAGE";
